module.exports = __webpack_public_path__ + "assets/img/Blue-Microphones-Landing-Page.38d792be.jpg";